import { BASE_URL, COMPANY_COMPETENCY } from "constants/api";
import axios from "../helpers/axiosInstance";
import { HeadCell } from "models/app";
import {
  ICompanyCompetency,
  ICompanyCompetencyInput,
} from "models/companyCompetencies";

export async function getCompanyCompetencies(
  params: string = ""
): Promise<ICompanyCompetency[]> {
  const response = await axios.get(BASE_URL + COMPANY_COMPETENCY + params);
  return response.data;
}
export async function addCompanyCompetencies(data: ICompanyCompetencyInput[]) {
  const response = await axios.post(BASE_URL + COMPANY_COMPETENCY, data);
  return response.data;
}

export async function editCompanyCompetencies(
  data: ICompanyCompetencyInput,
  id: string
) {
  const response = await axios.patch(
    BASE_URL + COMPANY_COMPETENCY + "/" + id,
    data
  );
  return response.data;
}

export async function deleteCompanyCompetencies(id: string) {
  const response = await axios.delete(BASE_URL + COMPANY_COMPETENCY + "/" + id);
  return response.data;
}

export const CompanyCompetencyCells: HeadCell[] = [
  {
    id: "name",
    numeric: false,
    disablePadding: false,
    label: "T_name",
  },
  {
    id: "nameAr",
    numeric: false,
    disablePadding: false,
    label: "T_name_Ar",
  },

  {
    id: "actions",
    numeric: false,
    disablePadding: false,
    label: "T_action",
  },
];
